import React from "react";
import { createColumnHelper, flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { Puff } from 'react-loading-icons';
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi";
import { AiFillInfoCircle, AiOutlineInfoCircle, AiOutlineSelect } from "react-icons/ai";

import { BsArrowUpShort, BsArrowDownShort } from "react-icons/bs";

import DownloadTable from '../main/DownloadTable';

import axios from "axios";
import $ from 'jquery'; 



// TABLE
function EventsTable(props){

    // for download
    const column_headers = [
        {
            label: 'ID',
            key: 'event_id',
        },
        {
            label: 'Study ID',
            key: 'event_investigation_id',
        },
        {
            label: 'Planned Visit ID',
            key: 'event_planned_visit_id',
        },
        {
            label: 'Participant ID',
            key: 'event_participant_id',
        },
        {
            label: 'Geolocation',
            key: 'event_geolocation',
        },
        {
            label: 'T0 Event Type',
            key: 't0_event_type',
        },
        {
            label: 'Start',
            key: 'event_start',
        },
        {
            label: 'Pseudostudyparticipanttime',
            key: 'event_pseudostudyparticipanttime',
        },
        {
            label: 'Duration',
            key: 'event_duration',
        },
        {
            label: 'Unit',
            key: 'event_unit',
        },
        {
            label: 'Category',
            key: 'event_category',
        },
        {
            label: 'Type',
            key: 'event_type',
        },
        {
            label: 'Material',
            key: 'immune_exposure_material',
        },
        {
            label: 'Sample type',
            key: 'specimen_type',
        },
        {
            label: 'Disease',
            key: 'immune_exposure_disease',
        },
        {
            label: 'Disease stage',
            key: 'immune_exposure_disease_stage',
        }
    ]

    // here you set a state to tell the component it need to wait
    //  until the result is fetched from the api
    const [loadingData, setLoadingData] = React.useState(true); 
    


    // use state to update data on load, currentpage, etc.
    const [data, setData] = React.useState([]);
    const [ordering, setOrdering] = React.useState();
    const [ordering_dir, setOrderingDir] = React.useState();
    const [pageNumber, setPageNumber] = React.useState();
    const [currentPage, setCurrentPage] = React.useState(1);
    const [inputPageValue, setInputPageValue] = React.useState('1');
    const [start, setStart] = React.useState(0);
    const [hasPrevious, setHasPrevious] = React.useState(false);
    const [hasNext, setHasNext] = React.useState(true);
    const offset = 50;

    const query = props.query;
    

    // full data url for download button
    const full_data_url = window.location.protocol + '//' + window.location.host + '/api_kb/get_full_events_data/' + query;



    // define URL to fetch rows (s=start, o=offset, q=query)
    const data_url = (s, o, q) => {
        return window.location.protocol + '//' + window.location.host + '/api_kb/get_slice_events/'+s+'/'+o+'/' + q;
    }


    // GET DATA
    React.useEffect(() => {

        async function get_events_data(url) {
            await axios
                .get(url)
                .then((response_events) => {
                    // check if the data is populated
                    // console.log(response_events.data);
                    setData(response_events.data.data);
                    setOrdering(response_events.data.ordering);
                    setOrderingDir(response_events.data.ordering_dir);
                    setPageNumber(response_events.data.number_page);
                    if (response_events.data.number_page == 1){
                        setHasNext(false);
                    }
                    props.length(response_events.data.length, 'events');
                    // you tell it that you had the result
                    setLoadingData(false);
                });
        }

        if (loadingData) {
            
            var query_onload = query;

            if (query != ''){
                query_onload += '&onload=True';
            }
            else {
                query_onload += '?onload=True';
            }

            const url = data_url(start, offset, query_onload);


            // if the result is not ready so you make the axios call
            get_events_data(url);
        }
    }, 
    []);





    // DEFINE COLUMNS
    const columnHelper = createColumnHelper();

    // define columns data, useMemo so the data isn't recreated on every render
    const columns = React.useMemo(
        () => [
            columnHelper.accessor('event_id', { 
                //accessorKey
                header: 'ID',
            }),
            columnHelper.accessor('event_investigation_id', { 
                //accessorKey
                header: 'Study ID',
                minSize: 80,
                cell: (props) => {
                    if (String(props.getValue()) !== "null"){
                        return (
                            <div>
                                <a href={`/query/study/` + props.getValue() }> {props.getValue()} </a>
                                <a className="select-cell-filter" title="click to filter" href={`/query/results/?study_id_filter=` + String(props.getValue()) + `&ordering_tab=events_tab`}><AiOutlineSelect/></a>
                            </div>
                        );
                    }
                    else {
                        return ('')
                    }
                },
            }),
            columnHelper.accessor('event_planned_visit_id', { 
                //accessorKey
                header: 'Planned Visit ID',
                minSize: 170,
            }),
            columnHelper.accessor('event_participant_id', { 
                //accessorKey
                header: 'Participant ID',
                minSize: 120,
                cell: (info) => {
                    if (String(info.getValue()) !== "null"){
                        return (
                            <div>
                                {String(info.getValue())}
                                <a className="select-cell-filter" title="click to filter" href={`/query/results/?participant_id_filter=` + String(info.getValue()) + `&ordering_tab=events_tab`}><AiOutlineSelect/></a>
                            </div>
                        );
                    }
                    else {
                        return ('')
                    }
                },
            }),
            columnHelper.accessor('event_geolocation', { 
                //accessorKey
                header: 'Geolocation',
                minSize: 140,
            }),
            columnHelper.accessor('t0_event_type', { 
                //accessorKey
                header: 'T0 Event Type',
                minSize: 260,
            }),
            columnHelper.accessor('event_start', { 
                //accessorKey
                header: 'Start',
            }),
            // columnHelper.accessor('event_pseudostudyparticipanttime', { 
            //     //accessorKey
            //     header: 'Pseudostudyparticipanttime',
            // }),
            // columnHelper.accessor('event_duration', { 
            //     //accessorKey
            //     header: 'Duration',
            // }),
            columnHelper.accessor('event_unit', { 
                //accessorKey
                header: 'Unit',
            }),
            columnHelper.accessor('event_category', { 
                //accessorKey
                header: 'Category',
                minSize: 200,
                cell: (info) => {
                    if (String(info.getValue()) !== "null"){
                        return (
                            <div>
                                {String(info.getValue())}
                                <a className="select-cell-filter" title="click to filter" href={`/query/results/?event_category_filter=` + String(info.getValue()).replace(/[^a-zA-Z0-9]/g, '') + `&ordering_tab=events_tab`}><AiOutlineSelect/></a>
                            </div>
                        );
                    }
                    else{
                        return ('')
                    }
                },
            }),
            columnHelper.accessor('event_type', { 
                //accessorKey
                header: 'Type',
                minSize: 270,
                cell: (info) => {
                    if (String(info.getValue()) !== "null"){
                        return (
                            <div>
                                {String(info.getValue())}
                                <a className="select-cell-filter" title="click to filter" href={`/query/results/?event_type_filter=` + String(info.getValue()).replace(/[^a-zA-Z0-9]/g, '') + `&ordering_tab=events_tab`}><AiOutlineSelect/></a>
                            </div>
                        );
                    }
                    else {
                        return ('')
                    }
                },
            }),
            columnHelper.accessor('immune_exposure_material', { 
                //accessorKey
                header: 'Material',
                minSize: 260,
                cell: (info) => {
                    const rowData = info.row.original; // Access the original row data
                    const materialID = rowData.immune_exposure_material_id;

                    if (String(info.getValue()) !== "null"){
                        return (
                            <div>
                                {String(info.getValue())}
                                <a className="select-cell-filter" title="click to filter" href={`/query/results/?material_filter=` + String(info.getValue()).replace(/[^a-zA-Z0-9]/g, '') + `&ordering_tab=events_tab`}><AiOutlineSelect/></a>
                                <a className="open-terminology-browser" title="open terminology browser" href={`/ontology/tree/?node=` + String(materialID)} target="_blank"><AiOutlineInfoCircle/></a>
                            </div>
                        );
                    }
                    else {
                        return ('')
                    }
                },
            }),
            columnHelper.accessor('specimen_type', {
                //accessorKey
                header: 'Sample Type',
                minSize: 300,
                cell: (info) => {
                    if (String(info.getValue()) !== "null"){
                        return (
                            <div>
                                {String(info.getValue())}
                                <a className="select-cell-filter" title="click to filter" href={`/query/results/?sample_type_filter=` + String(info.getValue()).replace(/[^a-zA-Z0-9]/g, '') + `&ordering_tab=events_tab`}><AiOutlineSelect/></a>
                            </div>
                        );
                    }
                    else{
                        return ('')
                    }
                },
            }),
            columnHelper.accessor('immune_exposure_disease', { 
                //accessorKey
                header: 'Disease',
                minSize: 260,
                cell: (info) => {
                    const rowData = info.row.original; // Access the original row data
                    const diseaseID = rowData.immune_exposure_disease_id;
                    
                    if (String(info.getValue()) !== "null"){
                        return (
                            <div>
                                {String(info.getValue())}
                                <a className="select-cell-filter" title="click to filter" href={`/query/results/?disease_filter=` + String(info.getValue()).replace(/[^a-zA-Z0-9]/g, '') + `&ordering_tab=events_tab`}><AiOutlineSelect/></a>
                                <a className="open-terminology-browser" title="open terminology browser" href={`/ontology/tree/?node=` + String(diseaseID)} target="_blank"><AiOutlineInfoCircle/></a>
                            </div>
                        );
                    }
                    else{
                        return ('')
                    }
                },
            }),
            columnHelper.accessor('immune_exposure_disease_stage', { 
                //accessorKey
                header: 'Disease stage',
                minSize: 200,
            }),
        ],
    []
    )




    // PAGINATION FUNCTIONNALITIES
    const nextPage = () => {

        async function get_event_data(url) {
            await axios
                .get(url)
                .then((response_event) => {
                    // check if the data is populated
                    // console.log(response_event);
                    setData(response_event.data.data);
                    setLoadingData(false);
                });
        }

        const next = start+offset;
        setStart(next);
        setCurrentPage(currentPage+1);
        setLoadingData(true);

        setHasPrevious(true);
        if (currentPage+1 === pageNumber){
            setHasNext(false);    
        }

        const url = data_url(next, offset, query);
        get_event_data(url);

    }

    const previousPage = () => {

        async function get_event_data(url) {
            await axios
                .get(url)
                .then((response_event) => {
                    // check if the data is populated
                    // console.log(response_event);
                    setData(response_event.data.data);
                    setLoadingData(false);
                });
        }

        const previous = start-offset;
        setStart(previous);
        setCurrentPage(currentPage-1);
        setLoadingData(true);

        setHasNext(true);
        if (currentPage-1 === 1){
            setHasPrevious(false);    
        }

        const url = data_url(previous, offset, query);
        get_event_data(url);

    }

    const firstPage = () => {

        async function get_event_data(url) {
            await axios
                .get(url)
                .then((response_event) => {
                    // check if the data is populated
                    // console.log(response_event);
                    setData(response_event.data.data);
                    setLoadingData(false);
                });
        }

        const start = 0;
        setStart(start);
        setCurrentPage(1);
        setHasPrevious(false);
        setHasNext(true);
        setLoadingData(true);

        const url = data_url(start, offset, query);
        get_event_data(url);

    }

    const lastPage = () => {

        async function get_event_data(url) {
            await axios
                .get(url)
                .then((response_event) => {
                    // check if the data is populated
                    // console.log(response_event);
                    setData(response_event.data.data);
                    setLoadingData(false);
                });
        }

        const start = (pageNumber-1)*offset;
        setStart(start);
        setCurrentPage(pageNumber);
        setHasNext(false);
        setHasPrevious(true);
        setLoadingData(true);

        const url = data_url(start, offset, query);
        get_event_data(url);

    }

    // checks on go to page
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            const page = Number(inputPageValue) - 1;
    
            if (page >= 1 && page <= pageNumber - 1) {
                gotoPage(page);

                if (page == 1) {
                    setHasNext(true);
                    setHasPrevious(false);    
                }

                else if (page == pageNumber){
                    setHasNext(false);
                    setHasPrevious(true);    
                }

                else {
                    setHasNext(true);
                    setHasPrevious(true);    
                }
            } 
            
            else if (page < 1) {
                gotoPage(0);
                setHasNext(true);
                setHasPrevious(false);
            } 
            
            else if (page > pageNumber - 1) {
                gotoPage(pageNumber - 1);
                setHasNext(false);
                setHasPrevious(true);
            }

        }, 1000); // Wait 1000ms after user stops typing
    
        return () => clearTimeout(timeout); // Clear if user types again
    
    }, [inputPageValue]); //execute when inputPageValue changes
    
    const gotoPage = (pageInt) => {

        async function get_event_data(url) {
            await axios
                .get(url)
                .then((response_event) => {
                    // check if the data is populated
                    // console.log(response_event);
                    setData(response_event.data.data);
                    setLoadingData(false);
                });
        }

        const start = (pageInt)*offset;
        setStart(start);
        setCurrentPage(pageInt+1);
        setLoadingData(true);

        if (pageInt+1 === pageNumber){
            setHasNext(false);
            setHasPrevious(true);    
        }
        else if (pageInt === 0){
            setHasNext(true);
            setHasPrevious(false);    
        }

        const url = data_url(start, offset, query);
        get_event_data(url);

    }

    


    // DEFINE TABLE 
    const table = useReactTable({ 
        columns, 
        data,
        getCoreRowModel: getCoreRowModel()
    })

    


    // RENDER
    return(

        <div className='EventsTable'>

            <div>

                <div className="results-table">

                    <table>
                        <thead>
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th className="column-pointer" {...{ key: header.id, colSpan: header.colSpan, style: { minWidth: header.getSize()} }} 
                                        onClick={()=>{
                                            if (ordering===header.id && ordering_dir==='asc'){
                                                props.onColumnOrdering(header.id, 'desc')
                                            }
                                            else {
                                                props.onColumnOrdering(header.id, 'asc');
                                            }
                                        }}
                                    >
                                        {header.isPlaceholder ? null : flexRender( header.column.columnDef.header, header.getContext())}
                                        <div className="column-order-icons">
                                            <i className={( ordering===header.id && ordering_dir==='asc' ) ? "order-selected" : ""}><BsArrowUpShort/></i>
                                            <i className={( ordering===header.id && ordering_dir==='desc' ) ? "order-selected" : ""}><BsArrowDownShort/></i>
                                        </div>

                                    </th>
                                ))}
                            </tr>
                            ))}
                        </thead>

                        {loadingData ? (
                            <div className="loader-container">
                                <Puff stroke="#ccd8de" strokeWidth={5}/>
                                <p>Loading...</p>
                            </div>
                        ):(

                            <tbody>
                                {table.getRowModel().rows.map((row) => (
                                    <tr key={row.id}>
                                        {row.getVisibleCells().map(cell => (
                                            <td key={cell.id}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        )}

                    </table>

                </div>

                <div className="pagination">
                    <button className="border-left" onClick={() => firstPage()} disabled={!hasPrevious}> <HiChevronDoubleLeft/> </button>
                    
                    <button onClick={() => previousPage()} disabled={!hasPrevious}> <HiOutlineChevronLeft/> </button>
                    
                    <div className="page-info">
                        <p><strong>{currentPage}</strong> of {pageNumber}</p>
                    </div>

                    <button onClick={() => nextPage() } disabled={!hasNext}> <HiOutlineChevronRight/> </button>
                    
                    <button className="border-right" onClick={() => lastPage()} disabled={!hasNext}> <HiChevronDoubleRight/> </button>
                    
                    <span className='current-page'> 
                        <span> Go to page:{' '}
                            <input type="number" min="1" max={pageNumber} defaultValue={1} onChange={(e) => setInputPageValue(e.target.value)}/>
                        </span> 
                    </span>  

                    <DownloadTable table_name={"Events / Samples Table"} url={full_data_url} columns_headers={column_headers} filename="event-table"/>

                </div>
            </div>
            
        </div>
    ) 
}

export default EventsTable;